import { render, staticRenderFns } from "./DetailVMinventory.vue?vue&type=template&id=062917e0&scoped=true"
import script from "./DetailVMinventory.vue?vue&type=script&lang=js"
export * from "./DetailVMinventory.vue?vue&type=script&lang=js"
import style0 from "./DetailVMinventory.vue?vue&type=style&index=0&id=062917e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062917e0",
  null
  
)

export default component.exports